module.exports = __webpack_public_path__ + "img/zsfw_reg.5cbbe8a6.png";